export class NotesDto {
  id?: number;
  crDate?: string;
  createdBy?: string;
  realPropertyId?: number;
  text?: string;
  fio?: string;
  photoUuid?: string;
  questionId?: number;
}
